/**
 * "You're out of credits", asked once.
 *
 * Three surfaces raise it — the Upgrade button, the planning composer's locked-model pick, and a
 * slide's Generate control — and each used to mount its own `Modal variant="upgrade"`. Same
 * question, same two answers, so it is one function here and a destination at each call site: the
 * three `onSeePlans` targets genuinely differ (a route push in some, a callback the host owns in
 * others) and unifying them would change behaviour, not just markup.
 *
 * Recoverable and additive, so `tone: 'primary'` — nothing is destroyed by running out of credits.
 */
import { confirmed } from '~/design-system/components/v1_5/Confirm';
import { planLabel, SubscriptionTier } from '~/queries/subscription';

/** Resolves true when the reader wants the plans page. */
export function askOutOfCredits(currentPlan: SubscriptionTier): Promise<boolean> {
  return confirmed({
    title: "You're out of credits",
    body: `You've used all your ${planLabel(currentPlan)} credits. Upgrade your plan, or wait for your next billing cycle.`,
    confirmLabel: 'See plans',
    cancelLabel: 'Not now',
    tone: 'primary',
  });
}
